import { BaseControlValueAccessor } from './BaseControlValueAccessor';

export class InputBooleanComponent extends BaseControlValueAccessor<boolean> {
    constructor() { super(false); }
}
